import axios from '../utils/axios';
import { ApiResponseBody } from '../types/subscription';
import { MaterialEventKind, MaterialEventResult, MaterialsPayload } from '../types/materials';

const unwrapBody = <T,>(response: { data: ApiResponseBody<T> }) => response.data.body;

export const materialsApi = {
    getMaterials: async () => unwrapBody<MaterialsPayload>(await axios.get('/api/materials')),
    recordEvent: async (materialId: string, kind: MaterialEventKind) =>
        unwrapBody<MaterialEventResult>(await axios.post('/api/material-event', { material_id: materialId, kind })),
};

/** `file_path` is relative to the API origin; REACT_APP_API_URL already ends at /api. */
export const materialFileUrl = (path: string | null): string | null =>
    path ? `${(process.env.REACT_APP_API_URL || '/api').replace(/\/+$/, '')}/${path}` : null;
